import React from "react";
import { Clock } from "@phosphor-icons/react";

const OPTIONS = [
  { value: "live", label: "Live" },
  { value: "7d", label: "7 giorni" },
  { value: "30d", label: "30 giorni" },
  { value: "1y", label: "1 anno" },
];

export default function PeriodSelector({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-slate-800 bg-[#0a0f1c] p-1" data-testid="period-selector">
      <div className="flex items-center gap-1 pl-2 pr-1 text-slate-500">
        <Clock size={12} />
        <span className="text-[10px] font-mono uppercase tracking-widest">Periodo</span>
      </div>
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          onClick={() => onChange(o.value)}
          data-testid={`period-${o.value}`}
          className={`px-3 py-1 rounded text-xs font-mono transition-colors ${
            value === o.value
              ? "bg-[#3EB6F0] text-[#070B14] font-semibold"
              : "text-slate-400 hover:text-slate-200 hover:bg-slate-800"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
